import { AxiosError } from "axios";
import { useCurrentCompanyId, useCurrentUser } from "hooks/auth";
import { Company } from "../types";
import { apiV1 } from "api-v2";
import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { logErrorIfDebug } from "utils/logging";
import { showToast } from "utils/helpers";
import * as constants from "actions/actionTypes";
import { ApiResponse } from "types/common.types";

export const useGetCompanyData = () => {
	const currentCompanyId = useCurrentCompanyId();
	const { guestUserEmail } = useCurrentUser();

	const dispatch = useDispatch();

	return useCallback(
		async (companyId: number | null = null) => {
			const useCompanyId = currentCompanyId ?? companyId;

			if (!useCompanyId) {
				logErrorIfDebug("useGetCompanyData had no Id passed in!");
				return;
			}

			dispatch({ type: constants.IS_LOADING, payload: true });

			try {
				const response = await apiV1.get<ApiResponse<Company>>(
					`companies/${useCompanyId}`,
					{
						params: {
							past_projects_published: true,
							email: guestUserEmail ?? "",
						},
					}
				);

				dispatch({
					type: constants.GET_COMPANY,
					payload: response.data?.data,
				});

				dispatch({ type: constants.IS_LOADING, payload: false });

				return response.data;
			} catch (error) {
				const axiosError = error as AxiosError<any>;
				const message =
					axiosError.response?.data?.message ||
					"Error fetching company details.";

				logErrorIfDebug("[Error] getCompany:", axiosError.response?.data);

				dispatch({ type: constants.IS_LOADING, payload: false });
				showToast(message, "Error");

				return axiosError.response?.data;
			}
		},
		[currentCompanyId, dispatch, guestUserEmail]
	);
};
